<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import PipelineAutomationsFlowBuilder from './components/PipelineAutomationsFlowBuilder.vue';
import FlowBuilder from './automations/FlowBuilder.vue';
import TemplatesGallery from './automations/components/TemplatesGallery.vue';

const { t } = useI18n();
const { showAlert } = useAlert();

const currentView = ref('list');
const editingAutomationId = ref(null);
const initialTab = ref('canvas');
const showTemplatesGallery = ref(false);

const showEditor = (automationId = null, tab = 'canvas') => {
  editingAutomationId.value = automationId;
  initialTab.value = tab;
  currentView.value = 'editor';
};

// Abre o editor diretamente na aba de histórico de execuções, sem o usuário
// precisar passar pelo canvas (pedido operacional: ver o que rodou/falhou).
const showHistory = automationId => showEditor(automationId, 'history');

const showList = () => {
  currentView.value = 'list';
  editingAutomationId.value = null;
  initialTab.value = 'canvas';
};

// Após save de automação, mantém o editor aberto na automação correta.
// Para nova automação, o backend retorna o id recém-criado — sem propagar,
// a próxima abertura precisaria ser feita pela lista (UX ruim e potencial
// fonte do bug "salvei e voltou em branco").
const handleSaved = savedId => {
  if (savedId) {
    editingAutomationId.value = savedId;
  }
};

const handleTemplateUsed = automation => {
  showTemplatesGallery.value = false;
  showAlert(t('PIPELINE.FLOW_BUILDER.TEMPLATES_GALLERY.SUCCESS_TOAST'));
  showEditor(automation.id);
};
</script>

<template>
  <div class="flex flex-col h-full w-full">
    <FlowBuilder
      v-if="currentView === 'editor'"
      :automation-id="editingAutomationId"
      :initial-tab="initialTab"
      @close="showList"
      @save="handleSaved"
    />
    <PipelineAutomationsFlowBuilder
      v-else
      @create="showEditor(null)"
      @edit="showEditor($event)"
      @history="showHistory($event)"
      @templates="showTemplatesGallery = true"
    />

    <!-- Templates Gallery Modal -->
    <TemplatesGallery
      v-if="showTemplatesGallery"
      @close="showTemplatesGallery = false"
      @template-used="handleTemplateUsed"
    />
  </div>
</template>
